// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3t8Wc","modalFooterButton":"ModalNotes_modalFooterButton__MsJ8F"};